import Notification from './Notification';

export type PersistentNotificationProps = {
    show: boolean;
    message: string;
};

const PersistentNotification = ({ show, message }: PersistentNotificationProps) => {
    return show ? (
        // Shows a persistent notification that cannot be closed
        // Doesn't use the global notifications area but its own instance so that this notification only appears in the current tab
        <div className="toast-notifications">
            <Notification
                notification={{
                    id: 1,
                    message: message,
                    type: 'info',
                    // isPersistent is false so that the close button doesn't appear, but this notification will not get cleared
                    isPersistent: false,
                }}
                dispatchNotification={() => {}}
            />
        </div>
    ) : null;
};

export default PersistentNotification;
